import { useState, useEffect, useCallback } from "react";
import { C, BRAND_LOGO } from "../../utils/statusMappings";
import { Icon, type IconName } from "../ui/Icon";

export const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@600;700;800;900&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;min-width:0}
  body{font-family:'Inter',system-ui,sans-serif;background:#FFF7F4;color:#2E2420;-webkit-font-smoothing:antialiased;overflow-x:hidden}
  h1,h2,h3,.cc-heading{font-family:'Plus Jakarta Sans','Inter',system-ui,sans-serif}
  html,#root{height:100%;max-width:100%;overflow-x:hidden}
  @keyframes spin    {to{transform:rotate(360deg)}}
  @keyframes shimmer {0%{background-position:200% 0}100%{background-position:-200% 0}}
  @keyframes slidein {from{transform:translateY(8px);opacity:0}to{transform:translateY(0);opacity:1}}
  @keyframes fadein  {from{opacity:0}to{opacity:1}}
  @keyframes popin   {0%{transform:scale(.95);opacity:0}60%{transform:scale(1.01)}100%{transform:scale(1);opacity:1}}
  .slide{animation:slidein .18s ease both}
  .pop  {animation:popin  .2s  ease both}
  button:focus-visible,a:focus-visible,input:focus-visible,select:focus-visible,textarea:focus-visible{outline:3px solid ${C.primary}44;outline-offset:2px}
  .login-page{overflow-x:hidden}
  .login-grid{width:100%;max-width:980px;display:grid;grid-template-columns:minmax(320px,420px) minmax(0,1fr);gap:22px;align-items:stretch}
  .cc-text-wrap{overflow-wrap:anywhere;word-break:normal}
  .cc-truncate{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
  .cc-responsive-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px}
  .cc-dashboard-wide{display:grid;grid-template-columns:1.15fr .85fr;gap:14px}
  .cc-dashboard-hero{background:linear-gradient(135deg, #fff, #FFF0F6);border:1px solid ${C.border};border-radius:24px;padding:18px;margin-bottom:18px;box-shadow:0 14px 42px rgba(122,78,58,0.07)}
  .cc-dashboard-hero-grid{display:grid;grid-template-columns:minmax(0,1.25fr) minmax(300px,.8fr);gap:16px;align-items:center}
  .cc-dashboard-kpi-pair{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
  .cc-dashboard-strategy-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px;margin-bottom:14px}
  .cc-dashboard-two-col{display:grid;grid-template-columns:minmax(0,1.12fr) minmax(280px,.88fr);gap:14px;margin-bottom:14px}
  .cc-dashboard-inner-two{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(220px,.9fr);gap:14px;align-items:center}
  .cc-dashboard-three-col{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin-bottom:14px}
  .cc-strategy-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(230px,1fr));gap:14px}
  .op-grid-4{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px}
  .op-grid-2{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}
  .op-workspace{display:grid;grid-template-columns:minmax(320px,420px) minmax(0,1fr);gap:16px;align-items:start}
  .cc-guide-shell{margin-bottom:16px}
  .wa-workspace{display:grid;grid-template-columns:minmax(260px,30%) minmax(360px,46%) minmax(240px,24%);gap:14px;align-items:start}
  .wa-panel{min-width:0;max-width:100%;overflow:hidden}
  .wa-card-scroll{max-height:calc(100vh - 300px);overflow:auto;padding-right:2px}
  .wa-mobile-only{display:none!important}
  .wa-tablet-context-button{display:none!important}
  .wa-message-bubble{max-width:min(76%,680px);overflow-wrap:anywhere;word-break:normal;white-space:pre-wrap}
  .wa-message-meta{display:flex;gap:8px;align-items:center;margin-top:8px;flex-wrap:wrap}
  .wa-context-dl{display:grid;grid-template-columns:minmax(96px,.38fr) minmax(0,1fr);gap:8px 10px}
  .wa-context-dl dt{font-size:10px;font-weight:800;color:${C.light};letter-spacing:.05em;text-transform:uppercase}
  .wa-context-dl dd{font-size:12px;color:${C.text};line-height:1.45;overflow-wrap:anywhere}
  .wa-context-drawer-backdrop,.mobile-drawer-backdrop{position:fixed;inset:0;background:rgba(63,35,49,.42);z-index:900;display:flex;justify-content:flex-end}
  .wa-context-drawer,.mobile-drawer{width:min(420px,92vw);height:100%;background:${C.surface};border-left:1px solid ${C.border};box-shadow:-18px 0 54px rgba(63,35,49,.18);overflow:auto;padding:16px}
  .mobile-menu-trigger{display:none!important}
  .quick-actions-trigger{position:fixed;right:24px;bottom:24px;z-index:500}
  .quick-actions-menu{position:fixed;right:24px;bottom:88px;z-index:499}
  .op-board{display:flex;gap:16px;overflow-x:auto;padding-bottom:16px;align-items:flex-start}
  .op-filterbar{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-bottom:16px}
  ::-webkit-scrollbar{width:4px;height:4px}
  ::-webkit-scrollbar-thumb{background:#F4C7D7;border-radius:2px}
  @media(max-width:1180px){
    .cc-dashboard-strategy-grid,.cc-dashboard-three-col{grid-template-columns:repeat(2,minmax(0,1fr))}
    .cc-dashboard-two-col,.cc-dashboard-inner-two{grid-template-columns:minmax(0,1fr)}
    .wa-workspace{grid-template-columns:minmax(250px,32%) minmax(0,1fr)}
    .wa-context-panel{display:none!important}
    .wa-tablet-context-button{display:inline-flex!important}
  }
  @media(max-width:768px){
    .desktop-sidebar{display:none!important}
    .mobile-nav{display:flex!important}
    .mobile-menu-trigger{display:inline-flex!important}
    .cc-app-main{padding-bottom:calc(176px + env(safe-area-inset-bottom))!important}
    .quick-actions-trigger{right:16px;bottom:calc(76px + env(safe-area-inset-bottom))}
    .quick-actions-menu{right:16px;bottom:calc(140px + env(safe-area-inset-bottom));max-width:calc(100vw - 32px)}
    input,select,textarea{font-size:16px!important}
    .hide-mobile{display:none!important}
    .login-page{align-items:flex-start!important;padding:16px 14px!important}
    .login-grid{grid-template-columns:minmax(0,1fr);gap:16px;max-width:430px}
    .cc-responsive-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
    .cc-dashboard-hero{padding:14px;border-radius:20px}
    .cc-dashboard-hero-grid,.cc-dashboard-strategy-grid,.cc-dashboard-three-col{grid-template-columns:minmax(0,1fr)}
    .cc-dashboard-kpi-pair{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
    .cc-dashboard-wide{grid-template-columns:minmax(0,1fr)}
    [data-guide-panel]{margin-left:0!important;margin-right:0!important}
    .cc-guide-shell{margin-bottom:12px}
    .cc-guide-shell [data-guide-panel]{max-height:220px;overflow:auto}
    .op-grid-4,.op-grid-2,.op-workspace{grid-template-columns:minmax(0,1fr)!important}
    .wa-workspace{display:block}
    .wa-hide-on-mobile{display:none!important}
    .wa-mobile-only{display:inline-flex!important}
    .wa-panel{margin-bottom:14px}
    .wa-card-scroll{max-height:none;overflow:visible;padding-right:0}
    .wa-message-bubble{max-width:94%}
    .op-board{display:grid;grid-template-columns:minmax(0,1fr);overflow:visible}
    .op-filterbar{align-items:stretch}
    .op-filterbar>*{width:100%}
  }
  @media(max-width:430px){
    .cc-responsive-grid{grid-template-columns:minmax(0,1fr)}
    .cc-dashboard-kpi-pair{grid-template-columns:minmax(0,1fr)}
  }
  @media(min-width:769px){.mobile-nav{display:none!important}}
`;

// ═══════════════════════════════════════════════════════════
// 2. ATOMS
// ═══════════════════════════════════════════════════════════

export const BrandLogo = ({ size = 54, compact = false }: { size?: number; compact?: boolean }) => (
  <div style={{ display: "flex", alignItems: "center", gap: compact ? 8 : 12, minWidth: 0 }}>
    <img
      src={BRAND_LOGO}
      alt="Cream Creations"
      style={{ width: size, height: size, borderRadius: Math.max(12, Math.round(size * 0.28)), objectFit: "contain", background: C.surface, border: `1px solid ${C.border}`, boxShadow: "0 12px 28px rgba(122,78,58,0.10)", flexShrink: 0 }}
      onError={e => { (e.currentTarget as HTMLImageElement).style.display = "none"; }}
    />
    {!compact && <div style={{ minWidth: 0 }}><div style={{ fontWeight: 900, fontSize: 14, color: C.primary, lineHeight: 1.1 }}>Cream Creations</div><div style={{ fontSize: 10, color: C.light, marginTop: 2 }}>Company OS v5.0</div></div>}
  </div>
);

export const ICON_NAMES = new Set([
  "layout-dashboard", "clock", "clock-alert", "message-circle", "users", "clipboard-list", "shopping-bag", "cake-slice", "factory", "truck", "indian-rupee", "wallet", "megaphone", "sparkles", "brain", "settings", "shield-check", "search", "bell", "triangle-alert", "route", "calendar-check", "chef-hat", "plus", "log-out", "user", "help-circle", "chevron-left", "chevron-right", "x", "check", "map-pin", "phone", "mail", "gauge"
]);
export const renderIcon = (icon: any, size = 18) => typeof icon === "string" && ICON_NAMES.has(icon)
  ? <Icon name={icon as IconName} size={size} />
  : icon;

export const Btn = ({ children, onClick, v = "primary", size = "md", disabled = false, loading = false, icon = "", full = false, style: sx = {} }: any) => {
  const sz: any = { xs: "4px 10px", sm: "6px 14px", md: "9px 20px", lg: "12px 26px" };
  const fs: any = { xs: 11, sm: 12, md: 13, lg: 14 };
  const mh: any = { xs: 28, sm: 34, md: 40, lg: 46 };
  const vr: any = {
    primary: { background: C.primary, color: "#fff", border: "none", boxShadow: `0 2px 8px ${C.primary}40` },
    secondary: { background: C.soft, color: C.primary, border: `1.5px solid ${C.accent}` },
    ghost: { background: "transparent", color: C.mid, border: `1px solid ${C.border}` },
    danger: { background: C.danger, color: "#fff", border: "none" },
    success: { background: C.success, color: "#fff", border: "none" },
  };
  return (
    <button disabled={disabled || loading} onClick={onClick}
      style={{ padding: sz[size], fontSize: fs[size], minHeight: mh[size], ...(vr[v] ?? vr.primary), borderRadius: 10, fontFamily: "inherit", fontWeight: 600, cursor: disabled || loading ? "not-allowed" : "pointer", opacity: disabled || loading ? 0.55 : 1, display: "inline-flex", alignItems: "center", gap: 6, justifyContent: "center", transition: "all .15s", width: full ? "100%" : undefined, ...sx }}
      onMouseEnter={e => { if (!disabled && !loading) { (e.currentTarget as any).style.filter = "brightness(1.08)"; (e.currentTarget as any).style.transform = "translateY(-1px)"; } }}
      onMouseLeave={e => { (e.currentTarget as any).style.filter = ""; (e.currentTarget as any).style.transform = ""; }}>
      {loading && <span style={{ width: 12, height: 12, border: "2px solid rgba(255,255,255,.3)", borderTop: "2px solid #fff", borderRadius: "50%", display: "inline-block", animation: "spin .7s linear infinite" }} />}
      {icon && !loading && <span style={{ display: "inline-flex", alignItems: "center", color: "currentColor" }}>{renderIcon(icon, 16)}</span>}
      {children}
    </button>
  );
};

export const Input = ({ label, value, onChange, type = "text", placeholder = "", required = false, error = "", options = null, rows = 0, disabled = false, suffix = "" }: any) => (
  <div style={{ marginBottom: 14 }}>
    {label && <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: C.mid, marginBottom: 5, letterSpacing: "0.05em", textTransform: "uppercase" as any }}>{label}{required && <span style={{ color: C.secondary }}> *</span>}</label>}
    <div style={{ position: "relative" }}>
      {options
        ? <select value={value} onChange={e => onChange(e.target.value)} disabled={disabled} aria-invalid={!!error} style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${error ? C.danger : C.border}`, borderRadius: 10, fontSize: 13, fontFamily: "inherit", background: C.surface, color: C.text, outline: "none", boxSizing: "border-box" as any }}><option value="">Select…</option>{options.map((o: string) => <option key={o} value={o}>{o}</option>)}</select>
        : rows > 1
          ? <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} rows={rows} aria-invalid={!!error} style={{ width: "100%", padding: "9px 12px", border: `1.5px solid ${error ? C.danger : C.border}`, borderRadius: 10, fontSize: 13, fontFamily: "inherit", background: C.surface, color: C.text, outline: "none", resize: "vertical", boxSizing: "border-box" as any }} onFocus={e => (e.currentTarget.style.borderColor = C.primary)} onBlur={e => (e.currentTarget.style.borderColor = error ? C.danger : C.border)} />
          : <input
              type={type}
              value={value}
              onChange={e => onChange(e.target.value)}
              onInput={e => {
                const nextValue = e.currentTarget.value;
                if (nextValue !== value) onChange(nextValue);
              }}
              placeholder={placeholder}
              disabled={disabled}
              aria-invalid={!!error}
              style={{ width: "100%", padding: `9px ${suffix ? "36px" : "12px"} 9px 12px`, border: `1.5px solid ${error ? C.danger : C.border}`, borderRadius: 10, fontSize: 13, fontFamily: "inherit", background: disabled ? C.bg : C.surface, color: C.text, outline: "none", boxSizing: "border-box" as any, opacity: disabled ? .7 : 1 }}
              onFocus={e => { if (!disabled) e.currentTarget.style.borderColor = C.primary; }}
              onBlur={e => { e.currentTarget.style.borderColor = error ? C.danger : C.border; }}
            />
      }
      {suffix && <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: C.light, pointerEvents: "none" }}>{suffix}</span>}
    </div>
    {error && <p role="alert" style={{ color: C.danger, fontSize: 11, marginTop: 3 }}>{error}</p>}
  </div>
);

export const Card = ({ children, style: sx = {}, onClick = null, urgency = "" }: any) => {
  const [h, setH] = useState(false);
  return <div onClick={onClick ?? undefined} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
    style={{ background: C.surface, borderRadius: 24, border: `1px solid ${C.border}`, borderLeft: urgency ? `4px solid ${urgency}` : undefined, padding: 20, boxShadow: h && onClick ? "0 26px 70px rgba(122,78,58,0.16)" : "0 18px 50px rgba(122,78,58,0.10)", cursor: onClick ? "pointer" : "default", transition: "box-shadow .22s ease,transform .22s ease", transform: h && onClick ? "translateY(-2px)" : "none", ...sx }}>
    {children}
  </div>;
};

export const Modal = ({ title, subtitle = "", children, onClose, width = 600 }: any) => {
  useEffect(() => { const h = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); }; window.addEventListener("keydown", h); return () => window.removeEventListener("keydown", h); }, []);
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      onKeyDown={(e: any) => {
        if (e.key !== "Tab") return;

        const focusable = Array.from(
          e.currentTarget.querySelectorAll(
            'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
          ),
        ) as HTMLElement[];

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }}
      style={{ position: "fixed", inset: 0, background: "rgba(63,35,49,0.45)", backdropFilter: "blur(8px)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 16px", animation: "fadein .15s ease" }}
    >
      <div className="pop" style={{ background: C.surface, borderRadius: 22, width: "100%", maxWidth: width, maxHeight: "90vh", overflow: "auto", boxShadow: "0 32px 80px rgba(63,35,49,0.22)" }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", padding: "22px 26px 18px", borderBottom: `1px solid ${C.border}`, position: "sticky", top: 0, background: C.surface, zIndex: 1 }}>
          <div><h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: C.primary }}>{title}</h2>{subtitle && <p style={{ margin: "3px 0 0", fontSize: 12, color: C.mid }}>{subtitle}</p>}</div>
          <button autoFocus aria-label="Close dialog" onClick={onClose} style={{ background: C.bg, border: "none", width: 32, height: 32, borderRadius: 9, cursor: "pointer", color: C.mid, fontSize: 17, display: "flex", alignItems: "center", justifyContent: "center" }} onMouseEnter={e => { (e.currentTarget as any).style.background = C.soft; (e.currentTarget as any).style.color = C.primary; }} onMouseLeave={e => { (e.currentTarget as any).style.background = C.bg; (e.currentTarget as any).style.color = C.mid; }}>×</button>
        </div>
        <div style={{ padding: "22px 26px" }}>{children}</div>
      </div>
    </div>
  );
};

export const Toast = ({ msg, type, onClose }: any) => (
  <div className="slide" style={{ position: "fixed", top: 20, right: 20, zIndex: 4000, background: type === "error" ? C.danger : type === "warning" ? C.warning : C.success, color: "#fff", padding: "13px 18px", borderRadius: 14, fontWeight: 600, fontSize: 13, boxShadow: "0 8px 32px rgba(0,0,0,.18)", display: "flex", gap: 10, maxWidth: 400, alignItems: "center" }}>
    <span style={{ fontSize: 16 }}>{type === "error" ? "✕" : type === "warning" ? "⚠" : "✓"}</span>
    <span style={{ flex: 1, lineHeight: 1.4 }}>{msg}</span>
    <button onClick={onClose} style={{ background: "rgba(255,255,255,.2)", border: "none", borderRadius: 6, width: 24, height: 24, cursor: "pointer", color: "#fff", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
  </div>
);

export const Skeleton = ({ h = 80 }: any) => <div style={{ height: h, background: `linear-gradient(90deg,${C.bg} 25%,${C.accent}20 50%,${C.bg} 75%)`, backgroundSize: "400% 100%", animation: "shimmer 1.4s infinite", borderRadius: 14, marginBottom: 12 }} />;

export const Badge = ({ children, color = C.primary }: any) => <span style={{ background: color + "18", color, fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 999, display: "inline-block", lineHeight: 1.6, whiteSpace: "nowrap" as any }}>{children}</span>;

export const StatusBadge = ({ status }: any) => {
  const s = C.STATUS[status] || C.STATUS.CONFIRMED;
  return <span style={{ background: s.bg, color: s.fg, fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 999, whiteSpace: "nowrap" as any }}>{s.label}</span>;
};

export const KPI = ({ label, value, sub, color, icon }: any) => (
  <div style={{ background: C.surface, borderRadius: 24, padding: "20px 22px", border: `1px solid ${C.border}`, borderTop: `3px solid ${color || C.primary}`, boxShadow: "0 18px 50px rgba(122,78,58,0.10)" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: C.light, textTransform: "uppercase" as any, letterSpacing: "0.07em", marginBottom: 8 }}>{label}</div>
      {icon && <span style={{ fontSize: 20, opacity: .55, color: color || C.primary, display: "inline-flex" }}>{renderIcon(icon, 22)}</span>}
    </div>
    <div style={{ fontSize: 30, fontWeight: 900, color: color || C.primary, lineHeight: 1 }}>{value}</div>
    {sub && <div style={{ fontSize: 11, color: C.mid, marginTop: 4 }}>{sub}</div>}
  </div>
);

export const SH = ({ title, action }: any) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
    <div style={{ fontSize: 11, fontWeight: 800, color: C.text, textTransform: "uppercase" as any, letterSpacing: "0.07em" }}>{title}</div>
    {action}
  </div>
);

export const Tabs = ({ items, active, onChange }: any) => (
  <div style={{ display: "flex", gap: 3, padding: 4, background: C.bg, borderRadius: 13, marginBottom: 18, flexWrap: "wrap" as any }}>
    {items.map((t: string) => <button key={t} onClick={() => onChange(t)} style={{ padding: "7px 16px", borderRadius: 10, border: "none", cursor: "pointer", fontSize: 12, fontFamily: "inherit", fontWeight: active === t ? 700 : 500, background: active === t ? C.surface : "transparent", color: active === t ? C.primary : C.mid, boxShadow: active === t ? "0 2px 6px rgba(127,39,77,0.10)" : "none", transition: "all .15s" }}>{t}</button>)}
  </div>
);

export const Row = ({ label, value }: any) => (
  <div style={{ display: "flex", padding: "9px 0", borderBottom: `1px solid ${C.bg}`, gap: 12 }}>
    <span style={{ fontSize: 11, fontWeight: 700, color: C.light, width: 140, flexShrink: 0, textTransform: "uppercase" as any, letterSpacing: "0.04em", paddingTop: 1 }}>{label}</span>
    <span style={{ fontSize: 13, color: C.text, flex: 1 }}>{value ?? <span style={{ color: C.light }}>—</span>}</span>
  </div>
);

export const Empty = ({ icon = "📭", title, desc, action }: any) => (
  <div style={{ display: "flex", flexDirection: "column" as any, alignItems: "center", padding: "56px 24px", textAlign: "center" as any }}>
    <div style={{ fontSize: 52, marginBottom: 16, opacity: .55, color: C.primary, display: "grid", placeItems: "center" }}>{renderIcon(icon, 48)}</div>
    <div style={{ fontSize: 17, fontWeight: 800, color: C.text, marginBottom: 8 }}>{title}</div>
    {desc && <div style={{ fontSize: 13, color: C.mid, maxWidth: 340, lineHeight: 1.6, marginBottom: 22 }}>{desc}</div>}
    {action && <Btn v="secondary" onClick={action.fn}>{action.label}</Btn>}
  </div>
);

export const useToast = () => {
  const [t, setT] = useState<any>(null);
  const show = useCallback((msg: string, type = "success") => { setT({ msg, type }); setTimeout(() => setT(null), 3800); }, []);
  return { t, show };
};

// ═══════════════════════════════════════════════════════════
// 3. DATA HOOKS — all defined once
// ═══════════════════════════════════════════════════════════
